// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* .list__group__header__append-icon {\n  display:none;\n} */\n.footer-class {\n  z-index: 300 !important;\n}\n", ""]);
// Exports
module.exports = exports;
